class ContactsWeb {
  static getAll() {
    console.warn("FIX ME!! ContactsWeb");
  };
};

export default ContactsWeb
